import { cn } from '../../lib/cn';

// Etykieta statusu. Kolory pochodzą z tokenów semantycznych, więc te same
// klasy dają poprawny kontrast w obu motywach — wcześniej kolory były wpisane
// wprost (bg-green-200 text-green-800) w łańcuchach warunków w trzech
// komponentach, przez co w trybie ciemnym byłyby nieczytelne.

const TONES = {
  success: 'border-success-line bg-success-soft text-success',
  info: 'border-info-line bg-info-soft text-info',
  warn: 'border-warn-line bg-warn-soft text-warn',
  danger: 'border-danger-line bg-danger-soft text-danger',
  neutral: 'border-neutral-line bg-neutral-soft text-neutral',
  accent: 'border-accent-line bg-accent-soft text-accent',
};

const SIZES = {
  sm: 'h-5 gap-1 px-1.5 text-2xs',
  md: 'h-6 gap-1.5 px-2 text-xs',
};

export function Badge({ tone = 'neutral', size = 'sm', icon: Icon, className, children }) {
  return (
    <span
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded border font-medium',
        TONES[tone] || TONES.neutral,
        SIZES[size],
        className
      )}
    >
      {Icon && <Icon size={size === 'sm' ? 11 : 13} className="shrink-0" />}
      {children}
    </span>
  );
}

export default Badge;
